import PropTypes from 'prop-types'

import Icon from 'components/Icon'
import theme from 'theme'

export default function SquareGlyph({
  icon,
  children,
  statusDotColor,
  backgroundColor,
  ...rest
}) {
  return (
    <div
      css={{
        height: 42,
        width: 42
      }}
      {...rest}
    >
      {statusDotColor && (
        <div
          css={{
            backgroundColor: statusDotColor,
            border: 'solid 2px white',
            borderRadius: '100%',
            boxSizing: 'content-box',
            height: theme.space[2],
            width: theme.space[2],
            minWidth: theme.space[2],
            marginLeft: 32,
            marginTop: 32,
            position: 'absolute',
            zIndex: 3
          }}
        />
      )}
      <div
        css={{
          backgroundColor: backgroundColor || theme.colors.gray[1],
          borderRadius: theme.borderRadius[1],
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          color: theme.colors.steel[1]
        }}
      >
        {children ? (
          children
        ) : (
          <Icon
            css={{
              width: 32,
              position: 'relative',
              top: 2,
              color: theme.colors.steel[1]
            }}
            icon={icon}
          />
        )}
      </div>
    </div>
  )
}

SquareGlyph.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.object,
  statusDotColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string
}
